import { ScratchPrize } from "../models/scratchPrize";

export const getWinningPrize = (scratchPrizes: ScratchPrize[]): ScratchPrize | null => {
  const totalProbability = scratchPrizes.reduce((sum, prize) => sum + (prize.probability || 0), 0);
  const unsetProbabilityCount = scratchPrizes.filter(prize => !prize.probability).length;

  if (totalProbability === 0) {
    const randomPrize = Math.floor(Math.random() * scratchPrizes.length);
    return scratchPrizes[randomPrize];
  }

  const remainingProbability = (1.0 - totalProbability) / unsetProbabilityCount;
  const normalizedscratchPrizes: ScratchPrize[] = scratchPrizes.map(scratchPrize => ({
    ...scratchPrize,
    probability: scratchPrize.probability || remainingProbability,
  }));

  const sumOfProbabilities = normalizedscratchPrizes.reduce((sum, scratchPrize) => sum + (scratchPrize.probability || 0), 0);
  const random = Math.random() * sumOfProbabilities;
  let cumulativeProbability = 0;

  for (let i = 0; i < normalizedscratchPrizes.length; i++) {
    cumulativeProbability += normalizedscratchPrizes[i].probability || 0;
    if (random < cumulativeProbability) {
      return normalizedscratchPrizes[i];
    }
  }
  return null;
};
